import { STATUS_CONFIG } from "@/lib/constants";
import { Pulse } from "@phosphor-icons/react";

export default function FleetLiveFeed({ assets, selectedId, onSelect }) {
  // Show active/transit/alert first
  const sorted = [...assets].sort((a, b) => {
    const order = { alert: 0, transit: 1, active: 2, idle: 3, maintenance: 4 };
    return (order[a.status] ?? 99) - (order[b.status] ?? 99);
  });

  return (
    <div className="bg-black/70 backdrop-blur-xl border border-white/10 w-[320px] max-h-[40vh] flex flex-col" data-testid="live-feed">
      <div className="px-4 py-3 border-b border-white/10 flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#71717a]">Fleet Feed</div>
          <div className="font-heading font-bold text-sm tracking-tight">Real-time Activity</div>
        </div>
        <Pulse size={14} weight="fill" className="text-[#ff8c00] ll-status-blink" />
      </div>
      <div className="flex-1 overflow-y-auto">
        {sorted.map((a) => {
          const config = STATUS_CONFIG[a.status] || STATUS_CONFIG.idle;
          const isSelected = a.id === selectedId;
          return (
            <button
              key={a.id}
              onClick={() => onSelect(a)}
              className={`w-full text-left px-4 py-3 border-b border-white/5 hover:bg-white/5 transition-colors flex items-center gap-3 ${
                isSelected ? "bg-[#ff8c00]/10 border-l-2 border-l-[#ff8c00]" : ""
              }`}
              data-testid={`feed-asset-${a.name}`}
            >
              <span
                className="w-2 h-2 rounded-full flex-shrink-0"
                style={{ background: config.color }}
              ></span>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-xs font-bold truncate">{a.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-[#71717a] truncate">
                  {a.driver || "Unassigned"} · {a.speed?.toFixed(0) || 0} MPH
                </div>
              </div>
              <span
                className="text-[9px] uppercase tracking-[0.2em] font-bold px-2 py-1"
                style={{ color: config.color, background: config.bg }}
              >
                {config.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
